import React from 'react';
import { Link } from 'react-router-dom';
import { Title, TrendingHolder, Links } from '../StyledComponents';

const trendingDiv = ({ trendingData }) => {
  let data = null;
  if (trendingData) {
    data = trendingData.map((tag, i) => {
      return (
        <Link
          key={tag.id}
          to={`tags/${tag.tagSlug}`}
          className="link pv1 ph2"
          style={{
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontWeight: 'bold',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#fff',
            textTransform: 'capitalize'
          }}
        >
          {tag.tagTitle}
        </Link>
      );
    });
  }

  return (
    <TrendingHolder>
      <div className="flex w-100 items-center" style={{ maxWidth: '1040px' }}>
        <Title
          className="pv2 ph3"
          fontFamily="Montserrat"
          fontSize="1.125rem"
          fontWeight="bold"
          color="#4db2ec"
        >
          Trending Today :
        </Title>
        <Links>{data ? data : null}</Links>
      </div>
    </TrendingHolder>
  );
};

export default trendingDiv;
